// Experience/World/World.js
import Tentacle from "./Tentacle.js";
import GodRays from "./GodRays.js";
// import Caustics from "./Caustics.js"; // Ajout

export default class World {
  constructor(scene, experience) {
    this.experience = experience;
    this.scene = scene;
    
    this.tentacle = new Tentacle(this.scene, this.experience);
    this.godRays = new GodRays(this.experience);
    // this.caustics = new Caustics(this.experience); // Initialisation
  }

  update() {
    if (this.tentacle) this.tentacle.update();
    if (this.godRays) this.godRays.update();
    if (this.caustics) this.caustics.update(); // Update
  }
}